import { type ContextMenuData } from '../types/context-menu-data.type';
import { emptyContextData } from './empty-context-data';

export const emptyContextMenuData = (): ContextMenuData => {
	return {
		context: emptyContextData(),
		position: { x: 0, y: 0 },
		relative: { x: 0, y: 0 }
	};
};
